// src/ducks.js
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  Edit,
  SimpleForm,
  Create,
  Show,
  SimpleShowLayout,
} from "react-admin";

// List view
export const DuckList = (props) => (
  <List {...props}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="type" />
    </Datagrid>
  </List>
);

// Create view
export const DuckCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="type" />
    </SimpleForm>
  </Create>
);

// Show view
export const DuckShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="type" />
    </SimpleShowLayout>
  </Show>
);

// Edit view (optional)
export const DuckEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="type" />
    </SimpleForm>
  </Edit>
);
